{
  "rowTypeName": {
    "companies": "Entreprises",
    "contacts": "Contacts",
    "key_activities": "Activités clés",
    "projects_opportunities": "Opportunités de projets",
    "opportunities": "Opportunités",
    "generic_items": "Éléments",
    "key_activity_dashboard": "Activités clés"
  },
  "actions": {
    "add_opportunity": "Ajouter une opportunité",
    "add_activity": "Ajouter une activité",
    "add_company": "Ajouter une entreprise",
    "add_contact": "Ajouter un contact",
    "add_generic_item": "Ajouter un élément"
  },
  "more_actions": {
    "more": "Plus",
    "large_list_view_title": "Vue de liste large",
    "large_list_view_description": "Améliore les performances, limite la recherche, le tri et les filtres.",
    "removed_history": "Historique supprimé",
    "list_settings": "Paramètres de liste"
  },
  "export": {
    "title": "Exporter",
    "confirmationModal": {
      "content": "L'exportation d'une grande liste inclura tous les {{rowTypeName}} et peut prendre du temps. Pour accélérer le processus, envisagez d'appliquer un filtre. Êtes-vous sûr de vouloir procéder à l'exportation de tous les {{rowTypeName}} sans aucun filtre ?"
    }
  }
}
